import { render, staticRenderFns } from "./ScanCanvas.vue?vue&type=template&id=ae618ac8&scoped=true&"
import script from "./ScanCanvas.vue?vue&type=script&lang=js&"
export * from "./ScanCanvas.vue?vue&type=script&lang=js&"
import style0 from "./ScanCanvas.vue?vue&type=style&index=0&id=ae618ac8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae618ac8",
  null
  
)

export default component.exports